export const WORKLIST_ACTIONS = {
  'UPDATE_TEMPLATE': 'WL_UPDATE_TEMPLATE',
  'INIT_TEMPLATES': 'WL_ACTIONS_INIT_TEMPLATES'
};
